
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2023-10-07-chrome-extension",
      function () {
        return require("private-next-pages/blogs/2023-10-07-chrome-extension/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2023-10-07-chrome-extension"])
      });
    }
  